import {
  ActivityFilterScreen,
  ActivityFilterScreenHandle,
  SlideAction,
  SlideLayout,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useCallback, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { HeaderResetButton } from '../../shared/components/headerResetButton';
import { useWindowDimensions } from '../../shared/hooks/useWindowDimensions';
import { ActivityFilters } from './activityFilters';
import { ActivityFoldOneColumn } from './activityFoldOneColumn';

export const ActivityFilterPage = () => {
  const filterRef = useRef<ActivityFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);

  const navigate = useNavigate();
  const { issueId } = useParams();
  const windowDimensions = useWindowDimensions();
  const windowHeight = windowDimensions?.height ?? 0;

  const maxHeight = windowHeight - 100;

  const onIssueSelected = useCallback(
    (issueId: string) => {
      navigate(`/activities/${issueId}`);
    },
    [navigate]
  );

  const leftColumn =  {
    title: 'activity.menu.title',
    mainComponent: (
      <ActivityLeftColumn
        onIssueSelected={onIssueSelected}
        showAssetName={true}
        selectedIssue={issueId}
        maxHeight={maxHeight}
        onDataLoaded={() => {}}
        hideFilterBar={true}
      />
    ),
    headerComponent: <ActivityFilters />,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'assets.menu.title',
    mainComponent: (
      <>
        <ActivityFilterScreen
          ref={filterRef}
          mode="page"
          isVisible={true}
          bottomBar={() => <></>}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton
        onReset={() => filterRef.current?.onReset()}
      />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const ActivityLeftColumn = ({
  onIssueSelected,
  showAssetName,
  selectedIssue,
  maxHeight,
  onDataLoaded,
  hideFilterBar,
}: {
  onIssueSelected: (issueId: string) => void;
  showAssetName: boolean;
  selectedIssue?: string;
  maxHeight: number;
  onDataLoaded: (data: unknown[]) => void;
  hideFilterBar: boolean;
}) => {
  const { onSlideChange, currentViewMode } = useSlideLayout();

  const handleIssueSelected = useCallback(
    (issueId: string) => {
      if (currentViewMode !== ViewMode.DUAL) {
        onSlideChange(SlideAction.DUAL);
      }
      onIssueSelected(issueId);
    },
    [onSlideChange, currentViewMode, onIssueSelected]
  );

  return (
    <ActivityFoldOneColumn
      onIssueSelected={handleIssueSelected}
      showAssetName={showAssetName}
      selectedIssue={selectedIssue}
      maxHeight={maxHeight}
      onDataLoaded={onDataLoaded}
      hideFilterBar={hideFilterBar}
    />
  );
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/activities', { state: { skipAutoSelect: true } });
  };

  return null;
};
